import CoursewareDefaultBlock from '../blocks/CoursewareDefaultBlock.vue';
import CoursewareDefaultContainer from './CoursewareDefaultContainer.vue';
// blocks
import CoursewareAudioBlock from '../blocks/CoursewareAudioBlock.vue';
import CoursewareBeforeAfterBlock from '../blocks/CoursewareBeforeAfterBlock.vue';
import CoursewareBiographyAchievementsBlock from '../blocks/CoursewareBiographyAchievementsBlock.vue';
import CoursewareBiographyCareerBlock from '../blocks/CoursewareBiographyCareerBlock.vue';
import CoursewareBiographyGoalsBlock from '../blocks/CoursewareBiographyGoalsBlock.vue';
import CoursewareBiographyPersonalInformationBlock from '../blocks/CoursewareBiographyPersonalInformationBlock.vue';
import CoursewareCanvasBlock from '../blocks/CoursewareCanvasBlock.vue';
import CoursewareChartBlock from '../blocks/CoursewareChartBlock.vue';
import CoursewareCodeBlock from '../blocks/CoursewareCodeBlock.vue';
import CoursewareConfirmBlock from '../blocks/CoursewareConfirmBlock.vue';
import CoursewareDateBlock from '../blocks/CoursewareDateBlock.vue';
import CoursewareDialogCardsBlock from '../blocks/CoursewareDialogCardsBlock.vue';
import CoursewareDocumentBlock from '../blocks/CoursewareDocumentBlock.vue';
import CoursewareDownloadBlock from '../blocks/CoursewareDownloadBlock.vue';
import CoursewareEmbedBlock from '../blocks/CoursewareEmbedBlock.vue';
import CoursewareErrorBlock from '../blocks/CoursewareErrorBlock.vue';
import CoursewareFolderBlock from '../blocks/CoursewareFolderBlock.vue';
import CoursewareGalleryBlock from '../blocks/CoursewareGalleryBlock.vue';
import CoursewareHeadlineBlock from '../blocks/CoursewareHeadlineBlock.vue';
import CoursewareIframeBlock from '../blocks/CoursewareIframeBlock.vue';
import CoursewareImageMapBlock from '../blocks/CoursewareImageMapBlock.vue';
import CoursewareKeyPointBlock from '../blocks/CoursewareKeyPointBlock.vue';
import CoursewareLinkBlock from '../blocks/CoursewareLinkBlock.vue';
import CoursewareLtiBlock from '../blocks/CoursewareLtiBlock.vue';
import CoursewareTableOfContentsBlock from '../blocks/CoursewareTableOfContentsBlock.vue';
import CoursewareTextBlock from '../blocks/CoursewareTextBlock.vue';
import CoursewareTimelineBlock from '../blocks/CoursewareTimelineBlock.vue';
import CoursewareTypewriterBlock from '../blocks/CoursewareTypewriterBlock.vue';
import CoursewareVideoBlock from '../blocks/CoursewareVideoBlock.vue';
//layout
import CoursewareCompanionBox from '../layouts/CoursewareCompanionBox.vue';
import StudipIcon from '../../StudipIcon.vue';
import StudipProgressIndicator from '../../StudipProgressIndicator.vue';

const ContainerComponents = {
    CoursewareDefaultBlock,
    CoursewareDefaultContainer,
    // blocks
    CoursewareAudioBlock,
    CoursewareBeforeAfterBlock,
    CoursewareBiographyAchievementsBlock,
    CoursewareBiographyCareerBlock,
    CoursewareBiographyGoalsBlock,
    CoursewareBiographyPersonalInformationBlock,
    CoursewareCanvasBlock,
    CoursewareChartBlock,
    CoursewareCodeBlock,
    CoursewareConfirmBlock,
    CoursewareDateBlock,
    CoursewareDialogCardsBlock,
    CoursewareDocumentBlock,
    CoursewareDownloadBlock,
    CoursewareEmbedBlock,
    CoursewareErrorBlock,
    CoursewareFolderBlock,
    CoursewareGalleryBlock,
    CoursewareHeadlineBlock,
    CoursewareIframeBlock,
    CoursewareImageMapBlock,
    CoursewareKeyPointBlock,
    CoursewareLinkBlock,
    CoursewareLtiBlock,
    CoursewareTableOfContentsBlock,
    CoursewareTextBlock,
    CoursewareTimelineBlock,
    CoursewareTypewriterBlock,
    CoursewareVideoBlock,
    //layout
    CoursewareCompanionBox,
    StudipIcon,
    StudipProgressIndicator,
};

export default ContainerComponents;
